import React, {useEffect, useRef, useState} from 'react';
import {ChevronDownIcon} from "@heroicons/react/16/solid";
import {Button, Input, Select} from "@headlessui/react";
import {ArrowUpTrayIcon, CheckCircleIcon} from "@heroicons/react/24/outline";
import {addDoc, collection, getDocs} from "firebase/firestore";
import {db} from "../firebase/firebase";
import * as XLSX from "xlsx";
import warehouse from "../PFC_Images/PFCWarehouse.JPG";
import {useAuth} from "../contexts/authContext";
import {useNotification} from "./Notifications/NotificationProvider";
import Loading from "./Widgets/Loading";
import FireworksEffect from "./Widgets/FireworksEffect";

const KissUpload = () => {
    
    const { currentUser } = useAuth();
    const { triggerNotification } = useNotification();
    
    const [showFireworks, setShowFireworks] = useState(false);
    
    const [name, setName] = useState("");
    const [batchID, setBatchID] = useState("");
    const [testType, setTestType] = useState("");
    const [sampleCount, setSampleCount] = useState("");
    const [rep, setRep] = useState("");
    const [repName, setRepName] = useState("");
    const [customer, setCustomer] = useState("");
    const [customerCode, setCustomerCode] = useState("");
    const [excelData, setExcelData] = useState([]);
    const [uploadedFileName, setUploadedFileName] = useState('');
    const fileInputRef = useRef(null);
    
    const clear = async () => {
        setName("");
        setBatchID("");
        setTestType("");
        setSampleCount("");
        setRep("");
        setCustomer("");
        setExcelData([]);
        setUploadedFileName('');
        
        // 👇 This resets the file input
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }
    
    const [users, setUsers] = useState([]);
    
    // Fetch users from Firestore on component mount
    useEffect(() => {
        const fetchUsers = async () => {
            const usersCollection = collection(db, 'Users');
            const userSnapshot = await getDocs(usersCollection);
            const userList = userSnapshot.docs.map(doc => ({
                id: doc.id, // UID from Firestore document ID
                name: `${doc.data().fname} ${doc.data().lname}`, // Combining fname and lname into a single name field
                accountLevel: doc.data().accountLevel,
                email: doc.data().email,
                phone:doc.data().phone,
            }));
            setUsers(userList);
        };
        fetchUsers();
    }, []);
    
    
    
    
    
    const [allCustomers, setAllCustomers] = useState([]);
    
    
    useEffect(() => {
        
        const fetchAllUsersActiveData = async () => {
            try {
                // Check if users is null or empty
                // if (!users || users.length === 0) {
                //     console.log("Users is null or empty. Returning an empty array.");
                //     setAllCustomers([]);
                //     setFilteredAllCustomers([]);
                //     // triggerNotification("soilRepError");
                //     return;
                // }
                
                const storedAllData = localStorage.getItem(`allCustomersLogan_${currentUser.uid}`);
                if (storedAllData) {
                    const allData = JSON.parse(storedAllData);
                    setAllCustomers(allData);
                    triggerNotification("soilCustLocal");
                } else {
                    // Extract user IDs from the users array
                    const userIds = users.map((user) => user.id);
            
                    let allClientsData = [];
            
                    // Iterate over user IDs and fetch clients for each
                    const userPromises = userIds.map(async (userId) => {
                        const clientsCollectionRef = collection(db, `Customers/${userId}/clients`);
                        const clientsSnapshot = await getDocs(clientsCollectionRef);
            
                        clientsSnapshot.forEach((clientDoc) => {
                            const data = clientDoc.data();
            
                            allClientsData.push({
                                id: clientDoc.id,
                                salesID: userId,
                                customerID: clientDoc.id, // this might be redundant with id
                                code: data.customerCode || '',
                                location: data.location || '',
                                // Add more fields as needed
                            });
                        });
                    });
            
                    // Wait for all users' client fetches to complete
                    await Promise.all(userPromises);
            
                    if (allClientsData.length > 0) {
                        setAllCustomers(allClientsData);
                        localStorage.setItem(`allCustomersLogan_${currentUser.uid}`, JSON.stringify(allClientsData));
                        triggerNotification("soilCust");
                    } else {
                        setAllCustomers([]);
                        triggerNotification("soilCustError");
                        localStorage.removeItem(`allCustomersLogan_${currentUser.uid}`);
                        console.log('No clients found, clearing data.');
                    }
                }
                
        
            } catch (error) {
                console.error("Error fetching clients data for all users: ", error);
            }
        };
        
        fetchAllUsersActiveData();

        // eslint-disable-next-line
    }, []);
    
    
    const [updating, setUpdating] = useState(false);

    const onUpdate = async () => {
        setUpdating(true);

        // User Data
        try {

            
            
            
            
            // Extract user IDs from the users array
            const userIds = users.map((user) => user.id);
    
            let allClientsData = [];
    
            // Iterate over user IDs and fetch clients for each
            const userPromises = userIds.map(async (userId) => {
                const clientsCollectionRef = collection(db, `Customers/${userId}/clients`);
                const clientsSnapshot = await getDocs(clientsCollectionRef);
    
                clientsSnapshot.forEach((clientDoc) => {
                    const data = clientDoc.data();
    
                    allClientsData.push({
                        id: clientDoc.id,
                        salesID: userId,
                        customerID: clientDoc.id, // this might be redundant with id
                        code: data.customerCode || '',
                        location: data.location || '',
                        // Add more fields as needed
                    });
                });
            });
    
            // Wait for all users' client fetches to complete
            await Promise.all(userPromises);
    
            if (allClientsData.length > 0) {
                setAllCustomers(allClientsData);
                localStorage.setItem(`allCustomersLogan_${currentUser.uid}`, JSON.stringify(allClientsData));
                triggerNotification("soilCust");
            } else {
                setAllCustomers([]);
                triggerNotification("soilCustError");
                localStorage.removeItem(`allCustomersLogan_${currentUser.uid}`);
                console.log('No clients found, clearing data.');
            }
            
            
            
            
            

        } catch (error) {
            console.error("Error fetching all pending orders", error);
        }
        

        setUpdating(false);
        
        triggerNotification("soilCust");
    };

    
    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
    
        if (!selectedFile) {
            triggerNotification("soilExcelErrorFile");
            return;
        }
    
        try {
            setUploadedFileName(selectedFile.name);
    
            const reader = new FileReader();
    
            reader.onload = (event) => {
                try {
                    const data = new Uint8Array(event.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
    
                    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    const parsedData = XLSX.utils.sheet_to_json(worksheet);
    
                    if (!parsedData || parsedData.length === 0) {
                        triggerNotification("soilExcelErrorEmpty");
                        throw new Error("Parsed Excel file is empty or invalid.");
                    }
    
                    setExcelData(parsedData);
                    triggerNotification("soilExcel"); // success
                } catch (parseError) {
                    console.error("Error parsing Excel file:", parseError);
                    triggerNotification("soilExcelFailed");
                    setExcelData([]); // clear on error
                }
            };
    
            reader.onerror = () => {
                console.error("FileReader error:", reader.error);
                triggerNotification("soilExcelError");
            };
    
            reader.readAsArrayBuffer(selectedFile);
        } catch (err) {
            console.error("Unexpected error during file upload:", err);
            triggerNotification("soilExcelErrorUnexpected");
        }
    
        console.log(selectedFile);
    };
    
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const docData = {
            name: name,
            batchID: batchID,
            testType: testType,
            sampleCount: sampleCount,
            rep: rep,
            repName: repName,
            customer: customer,
            customerCode: customerCode.toString(),
            uploadedTime: new Date(),
            results: excelData, // this is the array of parsed rows
        };
    
        try {
            await addDoc(collection(db, 'Customers', rep, 'clients', customer, 'SoilTests'), docData);
            triggerNotification("soilUpload");
            
            setShowFireworks(true);
            setTimeout(() => setShowFireworks(false), 5000); // Hide fireworks after 5 seconds
    
            await clear();
        } catch (error) {
            triggerNotification("soilUploadError");
            console.error('Error uploading to Firestore:', error);
        }
    };

  
    return (
        
        <div className="h-dvh px-12 text-black flex items-center justify-center overflow-scroll">
            
            {updating && (
                <Loading/>
            )}
            
            {showFireworks && <FireworksEffect show={showFireworks} />}
            
            <svg
                aria-hidden="true"
                className="absolute inset-x-0 top-0 -z-10 h-[64rem] w-full stroke-gray-200 [mask-image:radial-gradient(32rem_32rem_at_center,white,transparent)]"
            >
                <defs>
                    <pattern
                        x="50%"
                        y={-1}
                        id="1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84"
                        width={200}
                        height={200}
                        patternUnits="userSpaceOnUse"
                    >
                        <path d="M.5 200V.5H200" fill="none"/>
                    </pattern>
                </defs>
                <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
                    <path
                        d="M-200 0h201v201h-201Z M600 0h201v201h-201Z M-400 600h201v201h-201Z M200 800h201v201h-201Z"
                        strokeWidth={0}
                    />
                </svg>
                <rect fill="url(#1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84)" width="100%" height="100%"
                      strokeWidth={0}/>
            </svg>
            <div
                aria-hidden="true"
                className="absolute left-1/2 right-0 top-0 -z-10 -ml-24 transform-gpu overflow-hidden blur-3xl lg:ml-24 xl:ml-48"
            >
                <div
                    style={{
                        clipPath:
                            'polygon(63.1% 29.5%, 100% 17.1%, 76.6% 3%, 48.4% 0%, 44.6% 4.7%, 54.5% 25.3%, 59.8% 49%, 55.2% 57.8%, 44.4% 57.2%, 27.8% 47.9%, 35.1% 81.5%, 0% 97.7%, 39.2% 100%, 35.2% 81.4%, 97.2% 52.8%, 63.1% 29.5%)',
                    }}
                    className="aspect-[801/1036] w-[50.0625rem] bg-gradient-to-tr from-green-600 to-green-600 opacity-30"
                />
            </div>
            
            <img
                alt=""
                src={warehouse}
                className="absolute inset-0 -z-10 size-full animate-fadeIn object-cover"
            />
            
            
            <div className="grid grid-cols-1 gap-x-8 gap-y-8 py-10 md:grid-cols-3 bg-white px-6 rounded-2xl border drop-shadow-2xl">
                <div className="px-4 sm:px-0">
                    <h2 className="text-base/7 font-semibold">Test Result Upload</h2>
                    <p className="mt-1 text-sm/6 text-gray-500">Please upload the raw data results from the soil test.</p>
                    
                    <Button onClick={onUpdate} className={`mt-3 bg-green-600 text-xs rounded-lg px-2 py-1 text-white tracking-widest hover:bg-opacity-50 drop-shadow`}>
                        Update Customers
                    </Button>
                    
                    {/*<span className={``}>SalesID: {rep}</span>*/}
                    {/*<span className={``}>CustomerID: {customer}</span>*/}
                </div>
                
                <form onSubmit={handleSubmit} className="bg-white shadow-xl ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
                    <div className="px-4 py-6 sm:p-8">
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
                            
                            <div className="relative sm:col-span-full">
                                <div aria-hidden="true" className="absolute inset-0 flex items-center">
                                    <div className="w-full border-t border-gray-300"/>
                                </div>
                                <div className="relative flex justify-center">
                                    <span
                                        className="bg-white px-3 text-base font-semibold tracking-widest">Identifiers</span>
                                </div>
                            </div>
                            
                            {/*Name DONE*/}
                            <div className="sm:col-span-3">
                                <label className="block text-sm/6 font-medium text-gray-900">
                                    Test Results Name
                                </label>
                                <div className="">
                                    <Input
                                        type="string"
                                        required={true}
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6"
                                    />
                                </div>
                            </div>
                            
                            {/*Batch ID DONE*/}
                            <div className="sm:col-span-3">
                                <label className="block text-sm/6 font-medium text-gray-900">
                                    Batch ID
                                </label>
                                <div className="">
                                    <Input
                                        type="string"
                                        required={true}
                                        value={batchID}
                                        onChange={(e) => setBatchID(e.target.value)}
                                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6"
                                    />
                                </div>
                            </div>
                            
                            {/*Test Type DONE*/}
                            <div className="sm:col-span-4">
                                <label className="block text-sm/6 font-medium text-gray-900">
                                    Test Type
                                </label>
                                <div className="grid grid-cols-1">
                                    <Select
                                        type="string"
                                        value={testType}
                                        required={true}
                                        onChange={(e) => setTestType(e.target.value)}
                                        className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6"
                                    >
                                        <option value={""}>Select Test...</option>
                                        <option value={"IWTS"}>Irrigation Water Test Suitability Package</option>
                                        <option value={"PSF"}>Physical with Sand Fraction</option>
                                        <option value={"CTP"}>Complete Tissue Package</option>
                                        <option value={"SPP"}>Saturated Paste Package</option>
                                        <option value={"SSP"}>Standard Soil Package</option>
                                        <option value={"CSP"}>Complete Soil Package</option>
                                    
                                    </Select>
                                    <ChevronDownIcon
                                        aria-hidden="true"
                                        className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                    />
                                </div>
                            </div>
                            
                            {/*Sample Count DONE*/}
                            <div className="sm:col-span-2">
                                <label className="block text-sm/6 font-medium text-gray-900">
                                    Sample Count
                                </label>
                                <div className="">
                                    <Input
                                        type="string"
                                        value={sampleCount}
                                        required={true}
                                        onChange={(e) => setSampleCount(e.target.value)}
                                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6"
                                    />
                                </div>
                            </div>
                            
                            
                            {/*PFC DIVIDER*/}
                            <div className="relative sm:col-span-full">
                                <div aria-hidden="true" className="absolute inset-0 flex items-center">
                                    <div className="w-full border-t border-gray-300"/>
                                </div>
                                <div className="relative flex justify-center">
                                    <span
                                        className="bg-white px-3 text-base font-semibold tracking-widest">Plant Food Company Inc.</span>
                                </div>
                            </div>
                            
                            {/*Sales Rep*/}
                            <div className="sm:col-span-3">
                                <label className="block text-sm/6 font-medium text-gray-900">
                                    Sales Rep
                                </label>
                                <div className="grid grid-cols-1">
                                    {/*<Select*/}
                                    {/*    type="string"*/}
                                    {/*    value={rep}*/}
                                    {/*    required={true}*/}
                                    {/*    onChange={(e) => setRep(e.target.value)}*/}
                                    {/*    className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6"*/}
                                    {/*>*/}
                                    {/*    <option value="">Select a Sales Rep</option>*/}
                                    {/*    {users*/}
                                    {/*        .filter(user => user.accountLevel === "S" || user.accountLevel === "A")*/}
                                    {/*        .map(user => (*/}
                                    {/*            <option key={user.id} value={user.id}>*/}
                                    {/*                {user.name}*/}
                                    {/*            </option>*/}
                                    {/*        ))}*/}
                                    {/*</Select>*/}
                                    
                                    <Select
                                        value={rep}
                                        required={true}
                                        onChange={(e) => {
                                            const selectedId = e.target.value;
                                            const selectedName = e.target.options[e.target.selectedIndex].dataset.name;
                                            setRep(selectedId);
                                            setRepName(selectedName);
                                        }}
                                        className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6"
                                    >
                                        <option value="">Select a Sales Rep</option>
                                        {users
                                            .filter(user => user.accountLevel === "S" || user.accountLevel === "A" || user.accountLevel === "D")
                                            .map(user => (
                                                <option key={user.id} value={user.id} data-name={user.name}>
                                                    {user.name}
                                                </option>
                                            ))}
                                    </Select>
                                    
                                    <ChevronDownIcon
                                        aria-hidden="true"
                                        className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                    />
                                </div>
                            
                            </div>
                            
                            {/*Customer*/}
                            <div className="sm:col-span-3">
                                <label className="block text-sm/6 font-medium text-gray-900">
                                    Customer
                                </label>
                                <div className="grid grid-cols-1">
                                    {/*<Select*/}
                                    {/*    type="string"*/}
                                    {/*    disabled={!rep}*/}
                                    {/*    value={customer}*/}
                                    {/*    required={true}*/}
                                    {/*    // onChange={(e) => setCustomer(e.target.value)}*/}
                                    {/*    onChange={(e) => {*/}
                                    {/*        const selectedId = e.target.value;*/}
                                    {/*        const selectedCode = e.target.options[e.target.selectedIndex].dataset.code;*/}
                                    {/*        setCustomer(selectedId);*/}
                                    {/*        setCustomerCode(selectedCode);*/}
                                    {/*    }}*/}
                                    {/*    className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6"*/}
                                    {/*>*/}
                                    {/*    <option value="">Select a Customer</option>*/}
                                    {/*    {allCustomers*/}
                                    {/*        .filter(user => user.salesID === rep)*/}
                                    {/*        .map(user => (*/}
                                    {/*            <option key={user.id} value={user.id}>*/}
                                    {/*                {user.code}*/}
                                    {/*            </option>*/}
                                    {/*        ))}*/}
                                    {/*</Select>*/}
                                    
                                    
                                    
                                    <Select
                                        type="string"
                                        disabled={!rep}
                                        value={customer}
                                        required={true}
                                        onChange={(e) => {
                                            const selectedId = e.target.value;
                                            const selectedCode = e.target.options[e.target.selectedIndex].dataset.code;
                                            setCustomer(selectedId);
                                            setCustomerCode(selectedCode);
                                        }}
                                        className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6"
                                    >
                                        <option value="">Select a Customer</option>
                                        {allCustomers
                                            .filter(user => user.salesID === rep)
                                            .map(user => (
                                                <option key={user.id} value={user.id} data-code={user.code}>
                                                    {user.code}
                                                </option>
                                            ))}
                                    </Select>
                                    
                                    
                                    
                                    <ChevronDownIcon
                                        aria-hidden="true"
                                        className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                    />
                                </div>
                            </div>
                            
                            
                            {/*File*/}
                            <div className={`${excelData?.length > 0 ? 'border-green-600' : 'border-gray-300'} sm:col-span-full border border-dashed h-36 rounded-lg flex flex-col items-center justify-center`}>
                                
                                <div
                                    className={`size-12 hover:scale-110 rounded-full border ${excelData?.length > 0 ? 'border-green-600' : 'border-gray-300'} border-dashed flex items-center justify-center relative transition-all`}>
                                    {excelData?.length > 0 ? (
                                        <CheckCircleIcon className="size-6 text-green-600"/>
                                    ) : (
                                        <ArrowUpTrayIcon className="size-6 text-gray-400"/>
                                    )}
                                    
                                    <label
                                        htmlFor="desktop-user-photo"
                                        className="absolute inset-0 flex size-full items-center justify-center text-sm font-medium text-white opacity-0 focus-within:opacity-100 hover:opacity-100"
                                    >
                                        <Input
                                            ref={fileInputRef}
                                            type="file"
                                            accept=".xlsx, .xls"
                                            onChange={handleFileChange}
                                            required={true}
                                            className="absolute inset-0 size-full cursor-pointer rounded-md border-gray-300 opacity-0"
                                        />
                                    </label>
                                </div>
                                
                                {excelData?.length > 0 && uploadedFileName && (
                                    <div className="text-sm text-green-600 mt-1 truncate max-w-xs text-center">{uploadedFileName}</div>
                                )}
                                
                                <div className={`${uploadedFileName ? 'hidden' : ''} text-sm text-gray-400 tracking-tighter mt-1`}>
                                    Drag & drop or click to browse (max. 10MB)
                                </div>
                            </div>
                        
                        
                        </div>
                    </div>
                    <div
                        className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
                        <Button type="button" onClick={clear} className="text-sm/6 font-semibold text-gray-900">
                            Clear
                        </Button>
                        <Button
                            type="submit"
                            disabled={!rep || !customer}
                            className={`${!rep || !customer ? 'bg-opacity-50' : ''} rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600`}
                        >
                            {!rep || !customer ? 'Select Rep & Customer' : 'Upload'}
                        </Button>
                    </div>
                </form>
            </div>
        
        </div>
    
    )
};


export default KissUpload;
